export const ReceivingLabelField = {
  returnId: "returnId",
  orderName: "orderName",
} as const;
export type ReceivingLabelField =
  (typeof ReceivingLabelField)[keyof typeof ReceivingLabelField];

export const defaultReceivingLabelField: ReceivingLabelField =
  ReceivingLabelField.returnId;

export interface ReceivingLabelSettings {
  enabled: boolean;
  encodedField: ReceivingLabelField;
}
